import * as React from 'react';
import { clsx as cx } from 'clsx';
import { isBefore, isAfter, lastDayOfMonth, startOfMonth, sub, add, isSameYear } from 'date-fns';
import { UIHeading3 } from '../../../../../typography';
import { ArrowDown16, ArrowL16, ArrowR16 } from '../../../../../prev/icons';
import { ECalendarPickerPage } from '../types';
import styles from './styles.module.css';
import { format } from '../../../../../internal/utils/date';
import { IconButton } from '../../IconButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CalendarPickerHeader(_ref) {
  var current = _ref.current,
    min = _ref.min,
    max = _ref.max,
    page = _ref.page,
    onChangeYearClick = _ref.onChangeYearClick,
    onPrevMonthClick = _ref.onPrevMonthClick,
    onNextMonthClick = _ref.onNextMonthClick;
  var isSingleYear = !!(min && max && isSameYear(min, max));
  var handleClickTitle = function handleClickTitle() {
    onChangeYearClick();
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles['header'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: cx(styles['title'], !isSingleYear && styles['clickable']),
      onClick: isSingleYear ? undefined : handleClickTitle,
      "data-test": page === ECalendarPickerPage.Year ? 'toCalendarView' : 'toYearsView',
      children: [/*#__PURE__*/_jsx(UIHeading3, {
        userSelect: "none",
        "aria-live": "polite",
        children: format('LLLL y', current)
      }), !isSingleYear && /*#__PURE__*/_jsx(IconButton, {
        className: cx(styles['icon-button'], page === ECalendarPickerPage.Year && styles['year-active']),
        "aria-label": page === ECalendarPickerPage.Year ? 'Открыт выбор года, переключить на календарь' : 'Открыт календарь, переключить на выбор года',
        children: /*#__PURE__*/_jsx(ArrowDown16, {
          color: "current_color"
        })
      })]
    }), page === ECalendarPickerPage.Month && /*#__PURE__*/_jsxs("div", {
      className: styles['buttons'],
      children: [/*#__PURE__*/_jsx(IconButton, {
        className: styles['icon-button'],
        onClick: onPrevMonthClick,
        disabled: !!(min && isBefore(lastDayOfMonth(sub(current, {
          months: 1
        })), min)),
        "aria-label": "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u043C\u0435\u0441\u044F\u0446",
        children: /*#__PURE__*/_jsx(ArrowL16, {
          color: "current_color"
        })
      }), /*#__PURE__*/_jsx(IconButton, {
        className: styles['icon-button'],
        onClick: onNextMonthClick,
        disabled: !!(max && isAfter(startOfMonth(add(current, {
          months: 1
        })), max)),
        "aria-label": "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u043C\u0435\u0441\u044F\u0446",
        children: /*#__PURE__*/_jsx(ArrowR16, {
          color: "current_color"
        })
      })]
    })]
  });
}